<template>
  <div class="main">
    <div class="p-banner" :style="'background-image: url('+banner+');'"> </div>
    <nav class="main-navigation trailer-nav">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="navbar-header news-bar">
              <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#main-menu">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div class="collapse navbar-collapse" id="main-menu">
              <ul class="menu">
                <li :class="{active:active_category(index)}"  v-for="(item,index) in mesh_data" :key="index">
                  <a href="javascript:;" v-if="!item.closed" @click="select_category(index)" v-text="item.name"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="proList-box mb20">
      <div class="container">
          <div class="left-box">
            <div class="pro-menu">
              <ul>
                <li v-for="item in products.list" :class="{active:active_product(item.name)}">
                  <a href="javascript:;" v-if="!item.closed" @click="select_product(item)"  v-text="item.name"></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="rig-box">
            <div>

              <!-- Nav tabs -->
              <ul class="nav nav-tabs details-tabs" role="tablist">
                <li role="presentation" class="active"><a href="#cases" aria-controls="home" role="tab" data-toggle="tab">Cases</a></li>
                <li role="presentation"><a href="#details" aria-controls="profile" role="tab" data-toggle="tab">Details</a></li>
              </ul>

              <!-- Tab panes -->
              <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="cases">

                  <div class="row">
                    <div class="col-sm-4" v-for="item in selected_product.pics">
                      <a href="javascript:;" @click="toProductDetail(item)" class="thumbnail">
                        <div class="pic-box" v-cloak>
                          <img :src="image_url_prefix+item.url">
                        </div>
                        <div class="caption" v-if="item.name">
                          <h3 v-text="item.name"></h3>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div role="tabpanel" class="tab-pane" id="details">
                  <div class="search-list">
                    <dl class="dl-horizontal" v-for="(value, key) in selected_product.info">
                      <dt v-text="key"></dt>
                      <!--
                      <dd><a href="#" v-text="value">></a></dd>
                      -->
                      <dd v-html="value"></dd>
                    </dl>
                  </div>
                  <div class="pic-box">
                    <img v-if="selected_product.detail_pic" :src="image_url_prefix+selected_product.detail_pic" alt="">
                  </div>
                </div>

              </div>

            </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import banner from "../assets/img/pro_banner.jpg";
    import mesh_data from "../assets/data/mesh_data"
    export default {
        name: 'Products',
        data :function() {
        return {
            banner: banner,
            mesh_data:mesh_data,
            products:[],
            selected_category:"",
            selected_product:{}
        }
      },
      mounted:function(){
        $("#cases .thumbnail").zoomify();
          console.info(this.selected_product);
      },
      created:function () {
            var index = sessionStorage.getItem("__selected_category__");
            if(index)
            {
                this.selected_category = index;
                this.products = this.mesh_data[index];
            }
            else
            {
                this.selected_category = 0;
                this.products = this.mesh_data[0];

            }
            this.selected_product = this.products.list[0];
      },
      methods:{
          active_category:function (index) {
              return index==this.selected_category;
          },
          active_product:function (name) {
              return name==this.selected_product.name;
          },
          select_category:function (index) {
              sessionStorage.setItem("__selected_category__",index);
              this.selected_category = index;
              this.products = this.mesh_data[index];
              this.selected_product = this.products.list[0];
          },
          select_product:function (product) {

              this.selected_product = product;

              if(this.selected_product.banner)
              {
                  this.banner = this.image_url_prefix + this.selected_product.banner;
              }
              else
              {
                  this.banner = banner;
              }
          },
          toProductDetail:function (item) {
              sessionStorage.setItem("__product_detail__",item);
              //this.$router.push("/productDetail");
          }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/products.vue